// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vulWNgXbgjW2lb_Bcc3i {
  max-width: 90rem;
  padding: 4rem 0 1.25rem 0;
}

.C9KmcsekXGSoSTsNy9Ih {
  margin-bottom: 4rem;
}

.nHKbSGd_p4xbMZ9olyti {
  display: grid;
  grid-template-columns: repeat(4, min-content);
  grid-gap: 2.5rem;
  gap: 2.5rem;
  justify-content: center;
  margin-bottom: 1rem;
}

.C4FpMY17AXiM8H1U_Vd6 {
  margin: 0 auto 1.5rem auto
}

.C4FpMY17AXiM8H1U_Vd6.ouRe1lV6AqCAEEZRraua {
    grid-column-start: span 2;
  }

.uVDof4q9PDZx8tyNR8EC {
  color: var(--primary-link-color);
  font-size: 1.125rem;
  line-height: 1.5rem;
}

@media only screen and
  (min-width: 1279px) and
  (max-width: 1439px) {
    .C4FpMY17AXiM8H1U_Vd6 .ktSFRKuCj_WBDL17FeNu {
      width: 16.0625rem
    }

      .C4FpMY17AXiM8H1U_Vd6 .ktSFRKuCj_WBDL17FeNu.APn1EHYTJBOgR9PVR0Uo {
        width: 34.6875rem;
      }
      .C4FpMY17AXiM8H1U_Vd6.ouRe1lV6AqCAEEZRraua .ktSFRKuCj_WBDL17FeNu {
        width: 34.6875rem;
      }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .vulWNgXbgjW2lb_Bcc3i {
    padding: 1.25rem 3rem;
  }

  .nHKbSGd_p4xbMZ9olyti {
    grid-template-columns: repeat(3, min-content);
    grid-gap: 2rem;
    gap: 2rem;
    margin-bottom: 1rem;
  }

  .C4FpMY17AXiM8H1U_Vd6 {
    margin: 0 auto 1.5rem auto;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .vulWNgXbgjW2lb_Bcc3i {
    padding: 5rem 2rem 1.25rem 2rem;
  }

  .C9KmcsekXGSoSTsNy9Ih {
    margin-bottom: 3.5rem;
  }

  .nHKbSGd_p4xbMZ9olyti {
    grid-template-columns: repeat(2, min-content);
    grid-gap: 1.5rem;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .C4FpMY17AXiM8H1U_Vd6 {
    margin: 0 auto 1rem auto;
  }
}

@media only screen and
  (max-width: 639px) {
  .vulWNgXbgjW2lb_Bcc3i {
    padding: 3rem 1rem 1.25rem 1rem;
  }

  .C9KmcsekXGSoSTsNy9Ih {
    margin-bottom: 2.25rem;
  }

  .nHKbSGd_p4xbMZ9olyti {
    grid-template-columns: repeat(2, min-content);
    grid-gap: 1rem;
    gap: 1rem;
    margin-bottom: 0.75rem;
  }

  .C4FpMY17AXiM8H1U_Vd6 {
    margin: 0 auto 0.75rem auto;
  }

  .uVDof4q9PDZx8tyNR8EC {
    font-size: 1rem;
    line-height: 1.375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MostChosenProducts/MostChosenProducts.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAiB;EACjB,yBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,gBAAS;EAAT,WAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;AAKF;;AAHE;IACE,yBAAyB;EAC3B;;AAGF;EACE,gCAAgC;EAChC,mBAAe;EACf,mBAAiB;AACnB;;AAEA;;;IAEI;MACE;IAKF;;MAHE;QACE,iBAAY;MACd;MAIA;QACE,iBAAY;MACd;AAGN;;AAEA;;;EACE;IACE,qBAAkB;EACpB;;EAEA;IACE,6CAA6C;IAC7C,cAAS;IAAT,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,0BAAwB;EAC1B;AACF;;AAEA;;;EACE;IACE,+BAA4B;EAC9B;;EAEA;IACE,qBAAmB;EACrB;;EAEA;IACE,6CAA6C;IAC7C,gBAAS;IAAT,WAAS;IACT,qBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EACE;IACE,+BAA4B;EAC9B;;EAEA;IACE,sBAAmB;EACrB;;EAEA;IACE,6CAA6C;IAC7C,cAAS;IAAT,SAAS;IACT,sBAAmB;EACrB;;EAEA;IACE,2BAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,qBAAiB;EACnB;AACF","sourcesContent":[".mostChosenProducts {\n  max-width: 1440px;\n  padding: 64px 0 20px 0;\n}\n\n.titleWrapper {\n  margin-bottom: 64px;\n}\n\n.products {\n  display: grid;\n  grid-template-columns: repeat(4, min-content);\n  gap: 40px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.item {\n  margin: 0 auto 24px auto;\n\n  &.product {\n    grid-column-start: span 2;\n  }\n}\n\n.showMore {\n  color: var(--primary-link-color);\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@media (--desktop-medium) {\n  .item {\n    & .productCard {\n      width: 257px;\n\n      &.withHand {\n        width: 555px;\n      }\n    }\n\n    &.product {\n      & .productCard {\n        width: 555px;\n      }\n    }\n  }\n}\n\n@media (--desktop-small) {\n  .mostChosenProducts {\n    padding: 20px 48px;\n  }\n\n  .products {\n    grid-template-columns: repeat(3, min-content);\n    gap: 32px;\n    margin-bottom: 16px;\n  }\n\n  .item {\n    margin: 0 auto 24px auto;\n  }\n}\n\n@media (--tablet) {\n  .mostChosenProducts {\n    padding: 80px 32px 20px 32px;\n  }\n\n  .titleWrapper {\n    margin-bottom: 56px;\n  }\n\n  .products {\n    grid-template-columns: repeat(2, min-content);\n    gap: 24px;\n    margin-bottom: 24px;\n  }\n\n  .item {\n    margin: 0 auto 16px auto;\n  }\n}\n\n@media (--mobile) {\n  .mostChosenProducts {\n    padding: 48px 16px 20px 16px;\n  }\n\n  .titleWrapper {\n    margin-bottom: 36px;\n  }\n\n  .products {\n    grid-template-columns: repeat(2, min-content);\n    gap: 16px;\n    margin-bottom: 12px;\n  }\n\n  .item {\n    margin: 0 auto 12px auto;\n  }\n\n  .showMore {\n    font-size: 16px;\n    line-height: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mostChosenProducts": `vulWNgXbgjW2lb_Bcc3i`,
	"titleWrapper": `C9KmcsekXGSoSTsNy9Ih`,
	"products": `nHKbSGd_p4xbMZ9olyti`,
	"item": `C4FpMY17AXiM8H1U_Vd6`,
	"product": `ouRe1lV6AqCAEEZRraua`,
	"showMore": `uVDof4q9PDZx8tyNR8EC`,
	"productCard": `ktSFRKuCj_WBDL17FeNu`,
	"withHand": `APn1EHYTJBOgR9PVR0Uo`
};
export default ___CSS_LOADER_EXPORT___;
